import React, { useState } from "react";
import "../css-coding/FaqAccordion.css";

const faqData = [
  {
    question: "What does The Growth Secret Media do?",
    answer:
      "We’re a creative agency helping brands grow through reels editing, YouTube content, personal branding, social media management, web design, and more. We make your brand look and perform better online.",
  },
  {
    question: "How can I start working with your team?",
    answer:
      "Just drop us a message on Instagram or WhatsApp. We’ll discuss your goals, suggest the right service, and guide you step-by-step from idea to execution.",
  },
  {
    question: "What makes your video editing services stand out?",
    answer:
      "Our editing is strategy backed, fast paced retention edit, and platform optimized. We don’t just make videos, we create content that drives engagement, followers, and sales.",
  },
  {
    question: "Do you offer monthly content packages?",
    answer:
      "Yes, we provide fully managed monthly content plans, from content planning and editing to posting and performance tracking, all tailored to your brand.",
  },
  {
    question: "Can you help with Instagram and YouTube growth?",
    answer:
      "Definitely. We handle everything from bio optimization and thumbnails to high performing content that gets views, saves, and organic leads.",
  },
  {
    question: "Do you offer any courses for editors or creators?",
    answer:
      "Yes! We offer a Reels Editing Masterclass and Graphic Designing Masterclass ,  free YouTube courses on Premiere Pro, After Effects, and color grading, perfect for both beginners and pros.",
  },
];

const FaqAccordion = () => {
  const [openIndex, setOpenIndex] = useState(0); // First item is open
  const [prevIndex, setPrevIndex] = useState(null);


const toggle = (index) => {
  setPrevIndex(openIndex);
  setOpenIndex(openIndex === index ? null : index);


   
  };

  return (
    <div className="faq-container">
      <div className="faq-left">
        <h1>FAQ.</h1>
        <p>
          Got questions? We’ve got answers. Here’s <br>
          </br>everything you need to know about working with us.
        </p>
      </div>
      <div className="faq-right">
        {faqData.map((item, index) => (
       

            <div
  key={index}
  className={`faq-item 
    ${openIndex === index ? "open" : ""}
    ${openIndex === index && prevIndex !== null && index > prevIndex ? "open-up" : ""}
  `}
  onClick={() => toggle(index)}
>

            <div className="faq-question" >
              <p>{item.question}</p>
              <span className="faq-icon-wrapper">
                <span className="faq-icon">+</span>
              </span>
            </div>
            {openIndex === index && item.answer && (
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqAccordion;
